var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransfer(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 108 79",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(54.500000, 39.000000) rotate(-90.000000) translate(-54.500000, -39.000000) translate(15.000000, -15.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.875,0.33093 C49.383772,0.39253 48.980739,0.86749 49,1.36218 L49,104.14343 C49.0081946,105.264382 49.036003,106.029635 49.0834251,106.439189 C49.1123919,106.689357 49.1991668,106.913687 49.34375,107.11218 C49.720061,107.439412 50.279939,107.439412 50.65625,107.11218 L77.65625,83.11218 C77.9600993,82.8883695 78.1120925,82.5125798 78.049273,82.1404652 C77.9864534,81.7683506 77.7195194,81.4632832 77.3590368,81.3516238 C76.9985541,81.2399644 76.6059138,81.3407289 76.34375,81.61218 L51,104.14343 L51,1.36218 C51.02261,0.78394 50.449092,0.25822 49.875,0.33093 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30614262,0.33093 C0.814914616,0.39253 0.411881616,0.86749 0.431142616,1.36218 L0.431142616,104.14343 C0.439337241,105.264382 0.467145595,106.029635 0.514567679,106.439189 C0.543534484,106.689357 0.630309463,106.913687 0.774892616,107.11218 C1.15120363,107.439412 1.71108161,107.439412 2.08739262,107.11218 L29.0873926,83.11218 C29.391242,82.8883695 29.5432351,82.5125798 29.4804156,82.1404652 C29.417596,81.7683506 29.150662,81.4632832 28.7901794,81.3516238 C28.4296967,81.2399644 28.0370564,81.3407289 27.7748926,81.61218 L2.43114262,104.14343 L2.43114262,1.36218 C2.45375262,0.78394 1.88023462,0.25822 1.30614262,0.33093 Z",
    id: "Shape-Copy",
    transform: "translate(14.962438, 53.840890) rotate(-180.000000) translate(-14.962438, -53.840890) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.2d8c99b3.svg";
export { ForwardRef as ReactComponent };